export default function ($http) {
    return function (vrm) {
        return $http.get(`api/VehicleDetailsCheck/Vrm/${ vrm }`)
                .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/enquiries/getVehicleDetailsCheck.js